import { InMemoryCache } from '@apollo/client';

export const createTreasuryCache = () =>
  new InMemoryCache({
    typePolicies: {
      TreasuryPaymentsQuery: {
        merge: true,
      },
      // Plans are not globally unique by id: plansWithCoupon returns the same plan ids
      // with coupon-dependent fields (appliedCoupon, finalPrice). Normalizing them by id
      // makes coupon variants overwrite each other, so cached no-coupon results keep
      // showing an applied coupon (and vice versa). Embed plans into each query result instead.
      TreasuryPaymentsPlan: {
        keyFields: false,
      },
    },
  });
